import { Injectable, OnDestroy } from '@angular/core';
import { Router, CanActivate, CanLoad, Route } from '@angular/router';
import 'rxjs/add/operator/toPromise';

import {
    AngularMenuItem,
    BaseWebApiService,
    DialogsService,
    WebApiRequest,
    WebApiRequestBase,
    LoginData,
    LogoutData,
    WebApiResponse,
    WebApiResponseBase,
    AngularAppConfig
} from 'angular-library';

import { userData, Portali } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserService implements CanActivate, CanLoad, OnDestroy {

    baseUrl;  // URL to web api
    menuItemList: AngularMenuItem[];
    baseServiceSubscripton: any;
    wp_db_prefix: string;

    constructor(private baseService: BaseWebApiService,
        private router: Router,
        private dialogsService: DialogsService) {
        this.baseUrl = baseService.URL_REST_PATH + environment.userController;
        this.baseServiceSubscripton = this.baseService.noAuthResponse.subscribe(() => {
            AngularAppConfig.clearUserData();
            this.router.navigate(['/login']);
        });
    }

    ngOnDestroy(): void {
        if (this.baseServiceSubscripton) { this.baseServiceSubscripton.unsubscribe(); }
    }

    getWp_db_prefix() {
        return atob(localStorage.getItem('TifosInRete_prefix'));
    }

    getPortale() {
        return atob(localStorage.getItem('TifosInRete_portale'));
    }
    
    setPortale( portale: string){
        localStorage.setItem('TifosInRete_portale', btoa(portale));
    }

    isUserAuthenticated(): boolean {
        let token: string = AngularAppConfig.getUserToken();
        if (token == null || token == '' || token == 'null') {
            AngularAppConfig.clearUserData();
            this.router.navigate(['/login']);
            return false;
        } else { return true; }
    }

    isUserAllowed(route: Route): boolean {
        let user: userData = this.getUserData();
        if (!user) { return false; }
        let userActions: Array<string> = [];
        if (user.ListaFunzioni) {
            user.ListaFunzioni.filter(x => x.action && x.action.trim() != '').forEach(y => userActions.push(y.action));
        }
        if (user.ListaFunzioniMenu) {
            user.ListaFunzioniMenu.filter(x => x.action && x.action.trim() != '').forEach(y => userActions.push(y.action));
        }
        return userActions.some(x => route.path.includes(x));
    }

    getUserData(): userData {
        if (!this.isUserAuthenticated()) { return null; }
        return AngularAppConfig.getUserData() as userData;
    }

    getMenuItemList(): AngularMenuItem[] {
        this.menuItemList = new Array<AngularMenuItem>();
        let user: userData = AngularAppConfig.getUserData();
        if (user && user.ListaFunzioniMenu) {
            user.ListaFunzioniMenu
                .sort((a, b) => { return a.ordine - b.ordine })
                .forEach(item => {
                    let a: AngularMenuItem = new AngularMenuItem();
                    a.action = item.action;
                    a.funzione = item.funzione;
                    a.icona = item.icona;
                    a.param = null;
                    this.menuItemList.push(a);
                });
        }
        if (!userData.hasAdministration(user)) {
            let index = -1;
            for (let i = 0; i < this.menuItemList.length; i++) {
                if (this.menuItemList[i].funzione == 'Visite Dirette') {
                    index = i;
                    break;
                }
            }
            if (index > -1) { this.menuItemList.splice(index, 1); }
        }
        return this.menuItemList;
    }

    getListaPortali(): Promise<WebApiResponse<Portali[]>> {
        return this.baseService.post(this.baseUrl + 'portali', new WebApiRequestBase()).then(p => {
            let response: WebApiResponse<Portali[]> = p as WebApiResponse<Portali[]>;
            return response;
        });
    }

    login(loginData: LoginData): Promise<WebApiResponse<userData>> {
        let request: WebApiRequest<LoginData> = new WebApiRequest<LoginData>();
        request.data = loginData;
        this.wp_db_prefix = loginData.wp_db_prefix;
        localStorage.setItem('TifosInRete_prefix', btoa(this.wp_db_prefix));

        return this.baseService.post(this.baseUrl + 'login', request).then(p => {
            let response: WebApiResponse<userData> = p as WebApiResponse<userData>;
            AngularAppConfig.setUserData(response.payload);
            return response;
        });
    }

    loginByToken(token: string): Promise<WebApiResponse<userData>> {
        let request: WebApiRequest<string> = new WebApiRequest<string>();
        request.data = atob(localStorage.getItem('TifosInRete_prefix')) + ',' + token;
        return this.baseService.post(this.baseUrl + 'login_by_token', request).then(p => {
            let response: WebApiResponse<userData> = p as WebApiResponse<userData>;
            AngularAppConfig.setUserData(response.payload);
            return response;
        });
    }

    logout(): Promise<WebApiResponseBase> {
        let request: WebApiRequestBase = new WebApiRequest();
        return this.baseService.post(this.baseUrl + 'logout', request).then(p => {
            let response: WebApiResponse<LogoutData> = p as WebApiResponse<LogoutData>;
            AngularAppConfig.clearUserData();
            AngularAppConfig.clearUserToken();
            this.router.navigate(['/login']);
            return response;
        });
    }

    canActivate(): boolean {
        return this.isUserAuthenticated();
    }

    canLoad(route: Route): boolean {
        let result: boolean = this.isUserAllowed(route);
        if (!result) {
            this.dialogsService.alert('Accesso non consentito', 'Non si dispone dei permessi sufficienti per visualizzare la risorsa richiesta.');
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/user.service.ts